import React from 'react';
import { Button } from '../../Atoms';

interface IncompleteActionsModalProps {
    isOpen: boolean;
    onClose: (result: { reason: string; notes: string } | null) => void;
    name: string;
}

const IncompleteActionsModal: React.FC<IncompleteActionsModalProps> = ({ isOpen, onClose, name }) => {

    const handleCancelOnClick = () => {
        onClose(null);
    };

    if (!isOpen) return null;

    return (
        <div className="complete-modal modal-overlay" onClick={() => onClose(null)}>
            <div className="modal-content incomplete" onClick={(e) => e.stopPropagation()}>
                <div className='modal-form'>
                    <div className='form-content'>
                        <h1 className='modal-header'>{name}</h1>
                        <div className='content'>
                            <p>
                               All actions must be complete before a POA can be Pass/Fail
                            </p>
                        </div>
                    </div>
                    <div className='button-container button-container-incomplete-actions button-spacing'>
                        <Button
                            type='secondary'
                            text="Cancel"
                            icon={false}
                            handleClick={handleCancelOnClick}
                            stateProp='enabled'
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IncompleteActionsModal;
